export const CANCEL_OPERATION = 'cancellation'
export const RETAIN_OPERATION = 'retention'
export const CHANGE_ADDRESS = 'changeAddress'
